export default function Project({ title, period, stack, highlights, gitLink }) {
  return (
    <div className="bg-surface-card p-5 sm:p-8 rounded-xl border border-surface-border shadow-lg transition-colors hover:border-accent-violet/40">
      <div className="flex flex-col gap-1 sm:flex-row sm:items-start sm:justify-between sm:gap-4 mb-2">
        <h3 className="text-xl font-semibold sm:text-2xl">{title}</h3>
        {period && <p className="text-sm text-gray-400 shrink-0">{period}</p>}
      </div>
      <p className="text-accent-cyan mb-4 italic text-sm sm:text-base">{stack}</p>
      <ul className="space-y-2 text-gray-300 mb-6 text-sm sm:text-base leading-relaxed">
        {highlights.map((item) => (
          <li key={item} className="flex gap-2">
            <span className="text-accent-violet shrink-0 mt-1.5">▸</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
      {gitLink && (
        <a
          className="inline-block px-5 py-2.5 border border-accent-violet/50 rounded-lg text-accent-violet transition-colors hover:bg-accent-violet/10"
          href={gitLink}
          target="_blank"
          rel="noreferrer"
        >
          GitHub →
        </a>
      )}
    </div>
  );
}
